export default function isNumber(value) {
    return typeof value === "number" && !isNaN(value);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/common/is-number.js
// module id = 522
// module chunks = 29